/** Function to scroll to a specific element on the page.
 *  Usually the top element, so we can scroll to the top of the page.
 */
export const scrollToById = (
  elementId: string,
  behavior: ScrollBehavior = 'smooth'
) => {
  const element = document.getElementById(elementId);
  element?.scrollIntoView({ behavior });
};
